import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './login.css';
import Header from '../../components/Header/Header';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from '../../Assets/favicon.png';
import { baseUrl } from '../../Urls';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const page = params.get('page') || 'management';


    useEffect(() => {
        const storedLogin = localStorage.getItem(`${page}-isLoggedIn`);

        if (storedLogin === 'true') {
            switch (page) {
                case 'sales-enq-list':
                    navigate('/sales-enq-list');
                    break;
                case 'customer':
                    navigate('/customer');
                    break;
                case 'estimation':
                    navigate('/estimation');
                    break;
                case 'sales-order':
                    navigate('/sales-order');
                    break;
                case 'management':
                    navigate('/management');
                    break;
                default:
                    navigate('/');
            }
        }
    }, [navigate, page]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        console.log('Page parameter:', page);

        toast.dismiss();

        try {
            const response = await axios.post(`${baseUrl}/api/auth/login`, {
                username,
                password,
                page
            }, {
                withCredentials: true
            });

            if (response.data.success) {
                toast.success('Login successful!', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "dark",
                    transition: Bounce,
                });

                localStorage.setItem(`${page}-isLoggedIn`, 'true');
                localStorage.setItem(`${page}-username`, username);

                setTimeout(() => {
                    switch (page) {
                        case 'sales-enq-list':
                            navigate('/sales-enq-list');
                            break;
                        case 'customer':
                            navigate('/customer');
                            break;
                        case 'estimation':
                            navigate('/estimation');
                            break;
                        case 'sales-order':
                            navigate('/sales-order');
                            break;
                        case 'management':
                            navigate('/management');
                            break;
                        default:
                            navigate('/');
                    }
                }, 2000);
            }
        } catch (error) {
            console.error('Login error:', error);
            toast.error('Invalid credentials or server error', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "dark",
                transition: Bounce,
            });
        }
        finally {
            setLoading(false);
        }
    };


    return (
        <>
            <Header />
            <div className="login-box">
                <img className="login-logo mb-3" src={logo} alt="login-logo" />
                <h2>Login</h2>
                <form onSubmit={handleSubmit}>
                    <div className="user-box">
                        <input className='login-input'
                            type="text"
                            name="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                        <label>Username</label>
                    </div>

                    <div className="user-box position-relative">
                        <input className='login-input'
                            type={showPassword ? "text" : "password"}
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <label>Password</label>

                        <span
                            className="password-toggle-icon"
                            onClick={() => setShowPassword((prev) => !prev)}
                            style={{
                                position: "absolute",
                                top: "35%",
                                right: "10px",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#888"
                            }}
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>
                    <div className="user-box d-flex justify-content-center">
                        <button className='login-btn' type="submit" disabled={loading}>
                            {loading ? "Logging in..." : "Login"}
                        </button>
                    </div>
                </form>
            </div>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
                transition={Bounce}
                closeButton={false}
            />
        </>
    );
}

export default Login;
